<template>
    <div class="startQuiz">
        <v-app>
            <div id="grad">
                <!-- <h4>Counter: {{ numCorrect }}/{{ numTotal }}</h4> -->
                <v-container fill-height mt-n4>
                    <v-row justify="center" align="center">
                        <v-col cols="11" md="9" lg="7" align="center">
                            <QuestionBox v-if="questions.length" :currentQuestion="questions[index]" :next="next" :increment="increment" :qno="index+1"/>
                        </v-col>
                    </v-row>
                </v-container>
            </div>
        </v-app>
    </div>
</template>



<script>

import db from "@/fb"
import QuestionBox from '../components/questionBox.vue'

export default {
    name: 'StartQuiz',
    components: {
        QuestionBox
    },
    data () {
        return {
            questions: [],
            index: 0,
            // timerCount: 30,
            numCorrect: 0,
            numTotal: 0
        }
    },
    // watch: {
    //     timerCount: {
    //         handler (value) {
    //             if (value > 0) {
    //                 setTimeout(() => {
    //                     this.timerCount--;
    //                 }, 1000);
    //             }
    //         },
    //         immediate: true
    //     }
    // },
    methods: {
        next () {
            this.numTotal++;
            // this.timerCount = 30;
            if (this.index != 19) {
                this.index++;
            }
            else {
                this.$router.push({ name: 'Result', params: { numCorrect: this.numCorrect }})
            }
        },
        increment (isCorrect) {
            if (isCorrect) {
                this.numCorrect++;
            }
        }
    },
    mounted () {
        var id = this.$route.params.id;
        var id2 = this.$route.params.id2;
        var name = this.$route.params.name;
        if (name == null) {
            let ref = db.collection('Subjects').doc(id);
            ref.get().then((snapshot) => {
                if(snapshot.exists) {
                var post = snapshot.data();
                this.Name = post['name'];
                }
                else {
                console.log("No such document!")
                }
            })
        }

        db.collection('Subjects').doc(id).collection('Quizes').doc(id2).collection('Questions').get().then((querysnapshot) => {
            querysnapshot.forEach(doc => {
                var quest = doc.data();
                quest.id = doc.id;
                this.questions.push(quest);
            })
        })
    }
}

</script>



<style lang="scss" scoped>

#grad {
    background-image: linear-gradient( #3594DD ,#5B16D0);
    height: 100%;
}

#timer {
    background-color: cyan;
}

</style>